
export default class BlobStorage {

  constructor () {
    this.blobs = new Map();
  }

  async getObjectURL (url, protect = false) {

    if (!this.blobs.has(url)) {
      try {
        // Keep as one-liner for ease of testing
        const blob = await fetch(url).then(res => res.blob());

        if (!blob.size) throw new Error(`Won't store empty content for '${url}'`);
        this.blobs.set(url, [URL.createObjectURL(blob), protect]);

      } catch (e) {
        console.warn(`Failed creating Object URL for '${url}'\n`, e);
        return null;
      }
    }

    const [url_blob] = this.blobs.get(url) || [];
    return url_blob;
  }

  async update (add_or_keep = []) {
    // Clean up
    const entries = Array.from(this.blobs.entries());
    const delete_keys = entries.reduce(
      (acc, [key, [_, protect]]) =>
        !protect && !add_or_keep.includes(key) ? [...acc, key] : acc,
      []
    );

    delete_keys.forEach(key => {
      const [url_blob] = this.blobs.get(key);
      URL.revokeObjectURL(url_blob);
      this.blobs.delete(key);
    });

    // Update blobs
    await Promise.all(
      add_or_keep.map(this.getObjectURL.bind(this))
    );
  }
}
